import { PERMISSIONS } from 'api/auth/constants';
import { IFormPermissions } from 'api/routingRuleset/constants';
import { PERMISSION_TYPE } from 'hooks/useRBAC';

export enum MERCHANTS_KEYS {
  ALL = 'merchants',
  API_USERS = 'api-users',
  CASCADING_SCHEMA = 'cascading-schema',
  CASCADING_SCHEMAS = 'cascading-schemas',
  CLIENT_COUNTRY_GROUPS = 'client-country-groups',
  MERCHANT = 'merchant',
  MERCHANT_BIN_GROUPS = 'merchant-bin-groups',
  MERCHANT_CASHIER_PAYMENT_METHODS = 'merchant-cashier-payment-methods',
  MERCHANT_CLIENTS_LIMITS = 'merchant-clients-limits',
  MERCHANT_COUNTRY_GROUPS = 'merchant-country-groups',
  MERCHANT_CUSTOM_ACTION = 'merchant-custom-action',
  MERCHANT_CUSTOM_ACTIONS = 'merchant-custom-actions',
  MERCHANT_OUTPUT_CHANNEL = 'merchant-output-channel',
  MERCHANT_OUTPUT_CHANNELS = 'merchant-output-channels',
  MERCHANT_OUTPUT_CHANNELS_LIST = 'merchant-output-channels-list',
  MERCHANT_ROUTING_RULESETS = 'merchant-routing-rulesets',
  MERCHANT_RULESETS = 'merchant-rulesets',
  MERCHANT_TERMINAL_BIN_GROUPS = 'merchant-terminal-bin-groups',
  MERCHANT_TERMINAL_COUNTRY_GROUPS = 'merchant-terminal-country-groups',
  MERCHANTS_NAMES = 'merchants_names',
  MERCHANTS_SCOPE = 'merchants_scope',
  PAYMENT_METHODS = 'payment-methods',
  ROUTING_SCHEMAS = 'routing-schemas',
  TRANSACTION_DATE = 'transaction-date',
}

export const INITIAL_OFF_COLUMNS_MERCHANTS = [
  'cardholderTransliteration',
  'enableCashier',
  'enableCascading',
  'useRoutingPriority',
  'useCardToken',
  'preMemorisedRouting',
  'useClientStatsForRouting',
  'useClientMaxStatsForRouting',
  'trustedSortingPriority',
  'repeatCallbackOnError',
  'webhookUrl',
  'returnSuccessUrl',
  'returnFailureUrl',
  'returnCancelUrl',
  'returnHoldUrl',
  'returnPayoutFailureUrl',
  'returnCashierUrl',
  'returnInProgressUrl',
  'returnInProgressTimeout',
];

export const MAIN_COLUMNS = ['name'];

export const VIEW_MERCHANT_PAGE: IFormPermissions = {
  CONDITION_TYPE: PERMISSION_TYPE.OR,
  PERMISSIONS: [
    PERMISSIONS.CAN_VIEW_MERCHANTS,
    PERMISSIONS.CAN_VIEW_CASHIER_PAYMENT_LIMITS,
    PERMISSIONS.CAN_VIEW_CASHIER_SETTINGS,
    PERMISSIONS.CAN_VIEW_CASHIER_PAYMENT_METHODS,
    PERMISSIONS.CAN_VIEW_API_USERS,
    PERMISSIONS.CAN_VIEW_PAYMENT_LINKS,
  ],
};
